import useRouter from '../../../hooks/useRouter'
import { useMemo, useState } from 'react'
import RadioGroup from '../../../components/RadioGroup/RadioGroup'
import { TABS_OPTIONS } from './constants'
import { TABS_OPTIONS_KEY } from '../MyOrganization/constants'
import { EditGpoDetails } from './EditGpoDetails/EditGpoDetails'
import { useSelector } from 'react-redux'
import { getUser } from '../../../redux/store/user/getters'
import { ROLES } from '../../Permission'
import { GpoDetails } from './GpoDetails/GpoDetails'

export const MyOrganizationGpo = () => {
  const user = useSelector(getUser)

  const { query, push } = useRouter()
  const [activeSubTab, setActiveSubTab] = useState(
    query?.type || TABS_OPTIONS[0].value
  )
  const handleTabs = (e) => {
    setActiveSubTab(e)
    push(e)
  }

  const canEditGpo = useMemo(() => {
    return user.role === ROLES.GPO_PRESIDENT
  }, [user.role])

  return (
    <div className="my-organisation-container">
      <RadioGroup.Buttons
        options={TABS_OPTIONS}
        defaultValue={activeSubTab}
        onChange={handleTabs}
        className="mt-0 mb-24"
      />
      {activeSubTab === TABS_OPTIONS_KEY.general && canEditGpo && (
        <EditGpoDetails />
      )}
      {activeSubTab === TABS_OPTIONS_KEY.general && !canEditGpo && (
        <GpoDetails />
      )}
    </div>
  )
}
